import { render, staticRenderFns } from "./TheTratamiento.vue?vue&type=template&id=85aeabd4&scoped=true&"
import script from "./TheTratamiento.vue?vue&type=script&lang=js&"
export * from "./TheTratamiento.vue?vue&type=script&lang=js&"
import style0 from "./TheTratamiento.vue?vue&type=style&index=0&id=85aeabd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85aeabd4",
  null
  
)

export default component.exports